// extracted by mini-css-extract-plugin
export default {"legal-wrapper":"LegalModal_legal-wrapper__+Ujng","header-style":"LegalModal_header-style__siSwu","subheader-style":"LegalModal_subheader-style__Bsxpp"};